import { startTransition, useOptimistic, type FC } from 'react';
import { defineMessage, useIntl } from 'react-intl';

import { Input } from '@packages/shared/src/ui/Input/Input';

const searchLabel = defineMessage({
  id: 'filters.basic.search.label',
  defaultMessage: '{filterName} suchen',
});

export type BasicFilterSearchBoxProps = {
  /** Name of the filter, for use in the search input label */
  filterName: string;
  /** current search query, uplifted input state binding */
  searchQuery: string;
  /** Setter for the current search query, uplifted input state binding */
  onChange?: (searchQuery: string) => void;
};

/**
 * BasicFilterSearchBox component description displayed in storybook
 * */
export const BasicFilterSearchBox: FC<BasicFilterSearchBoxProps> = ({
  filterName,
  searchQuery,
  onChange,
}) => {
  const { formatMessage } = useIntl();
  const [optimisticValue, setOptimistic] = useOptimistic(searchQuery);

  return (
    <Input
      containerClassName="p-2 [grid-area:'header'] shadow-sm"
      className="w-full"
      label={formatMessage(searchLabel, { filterName })}
      id="filter-value-search-input"
      value={optimisticValue}
      onChange={(event) => {
        startTransition(() => {
          setOptimistic(event.target.value);
          onChange?.(event.target.value);
        });
      }}
    />
  );
};
